import type { Configuration, PopupRequest } from '@azure/msal-browser';

const tenantId = import.meta.env['VITE_GE_TENANT_ID'] ?? '';
const clientId = import.meta.env['VITE_GE_AUTH_CLIENT_ID'] ?? '';

export const apiBaseUrl: string = import.meta.env['VITE_GE_API_BASE_URL'] ?? '';

export const isAuthConfigured = Boolean(tenantId && clientId);

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: false,
  },
  cache: { cacheLocation: 'sessionStorage', storeAuthStateInCookie: false },
};

export const loginRequest: PopupRequest = {
  scopes: [`api://${clientId}/access_as_user`],
};
